import ComparatorChart from "./ComparatorChart.jsx";
import AssetSelector from "../util/asset-selector/AssetSelector.jsx";
import {useDispatch, useSelector} from "react-redux";
import {getAssetId1, getAssetId2, setAssetId1, setAssetId2} from "../../ducks/comparator-duck.js";
import Button from "../util/Button.jsx";
import './ComparatorPage.scss'
import SwapVerticalIcon from "mdi-react/SwapVerticalIcon.js";
import DurationSelector from "./DurationSelector.jsx";
import {ASSET_COLOR_1, ASSET_COLOR_2} from "./_helpers.js";
import ComparatorSummary from "./ComparatorSummary.jsx";
import ComparatorStoredPairs from "./ComparatorStoredPairs.jsx";

export default () => {

    const dispatch = useDispatch()

    const assetId1 = useSelector(getAssetId1)
    const assetId2 = useSelector(getAssetId2)

    const flipAssets = () => {
        dispatch(setAssetId1(assetId2))
        dispatch(setAssetId2(assetId1))
    }

    return (
        <div className='comparator-page'>
            <DurationSelector />
            <ComparatorChart/>
            <ComparatorSummary />
            <div className='asset-selectors'>
                <div className='asset'>
                    <div className='color a1' style={{ backgroundColor: ASSET_COLOR_1, }} />
                    <AssetSelector
                        headerSelected='Base asset'
                        selectedAssetId={assetId1}
                        selectAsset={assetId => dispatch(setAssetId1(assetId))}
                    />
                </div>
                <div className='flip-button-container'>
                    <Button
                        onClick={flipAssets}
                        icon={<SwapVerticalIcon/>}
                    >
                        Flip assets
                    </Button>
                </div>
                <div className='asset'>
                    <div className='color a2' style={{ backgroundColor: ASSET_COLOR_2, }} />
                    <AssetSelector
                        headerSelected='Compared to asset'
                        selectedAssetId={assetId2}
                        selectAsset={assetId => dispatch(setAssetId2(assetId))}
                    />
                </div>
            </div>
            <ComparatorStoredPairs />
        </div>
    )
}